export default __webpack_public_path__ + "static/GenericImageActionListWithCharTitle-4f09939692b8817ff1a4807bf2eb2351.jpg";